

























import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

type SwitchValue = -1 | 0 | 1;

@Component({})
export default class MbeSwitch extends Vue {
  @Prop({
    default: false
  })
  value: SwitchValue;

  @Prop({
    default: false
  })
  disabled: boolean;

  @Prop({
    default: null
  })
  label: string;

  @Prop({
    default: "yes"
  })
  truthyLabel: string;

  @Prop({
    default: "no"
  })
  falsyLabel: string;

  onSwitchClick(newValue: SwitchValue) {
    if (newValue === this.value) return;
    this.$emit("click", newValue);
  }
}
